// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t3mc","question":"styles_question__2VwcJ","description":"styles_description__3Qyln"};